import { ColouredCard } from '@zoopla-eng/zds/coloured-card';
import { Link } from '@zoopla-eng/zds/link';
import {
    PictogramHouseOnHill,
    PictogramHouseWithChimney,
    PictogramSkyscrapers
} from '@zoopla/assets';
import { FC } from 'react';
import {
    coloredCardContainerStyle,
    coloredCardListStyle
} from './InstantValuationCTA.styles.css';

type InstantValuationCTAProps = {
    areaName: string;
    slug: string;
};

export const InstantValuationCTA: FC<InstantValuationCTAProps> = ({
    areaName,
    slug
}) => {
    return (
        <aside aria-label="Links to help you find your next property">
            <ul className={coloredCardContainerStyle}>
                <li className={coloredCardListStyle}>
                    <ColouredCard
                        backgroundColor="graphicSellingLight"
                        alignItems="center"
                    >
                        <img src={PictogramHouseOnHill} alt="" />
                        <Link href={`/for-sale/property/${slug}/`}>
                            {`Properties for sale in ${areaName}`}
                        </Link>
                    </ColouredCard>
                </li>
                <li className={coloredCardListStyle}>
                    <ColouredCard
                        backgroundColor="graphicPriceLight"
                        alignItems="center"
                    >
                        <img src={PictogramSkyscrapers} alt="" />
                        <Link href={`/to-rent/property/${slug}/`}>
                            {`Properties to rent in ${areaName}`}
                        </Link>
                    </ColouredCard>
                </li>
                <li className={coloredCardListStyle}>
                    <ColouredCard
                        backgroundColor="graphicImprovingLight"
                        alignItems="center"
                    >
                        <img src={PictogramHouseWithChimney} alt="" />
                        <Link href={`/new-homes/property/${slug}/`}>
                            {`New-build homes in ${areaName}`}
                        </Link>
                    </ColouredCard>
                </li>
            </ul>
        </aside>
    );
};
